<script>
export default {
  name: 'TwContainer'
}
</script>

<template>
  <div class="md:container md:mx-auto px-5 md:px-8">
    <slot />
  </div>
</template>

<style scoped>

</style>
